import React, { useState } from "react";
import { ErrorMessage, Formik } from "formik";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import Alert from "@mui/material/Alert";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/material/Grid2";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import Snackbar from "@mui/material/Snackbar";
import {NavLink ,useNavigate} from "react-router-dom";
import LockOpenRoundedIcon from "@mui/icons-material/LockOpenRounded";
import config from "../config/Config";
import InputAdornment from "@mui/material/InputAdornment";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import "../styles/authStyles/forgotPassword.css";
import IconButton from "@mui/material/IconButton";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff"

const ChangePassword = (props) => {
  const navigate = useNavigate();
  const {open,close}=props
  const [openSnackbar, setOpenSnackbar] =useState(false);
  const [detail, setDetail] = useState('');
	const [severityType, setSeverityType] = useState('');
  const [showCurrentPassword, setShowCurrentPassword] =useState(false);
	const [showNewPassword, setShowNewPassword] =useState(false);
	const [showConfirmPassword, setShowConfirmPassword] =useState(false);
	const vertical = 'top';
	const horizontal = 'center';

	const handleKeyDown = (e) => {
		if (e.key === " ") {
		  e.preventDefault();
		}
	  };

    const initialValues = {
      current_password: '',
      new_password: '',
      confirm_password: ''
    }

    const validate = (values) => {
      let errors = {}
  
      if (!values.current_password) {
        errors.current_password = 'Please enter  current password'
      }
      if (!values.new_password) {
        errors.new_password = 'Please enter new password'
      } else if (values.new_password.length <= 6) {
        errors.new_password = "Must be more than 6 characters";
      }
      if (!values.confirm_password) {
        errors.confirm_password = 'Please enter confirm password'
      } else if (values.confirm_password.length <= 6) {
        errors.confirm_password = "Must be more than 6 characters";
      }
      return errors;
    }
  
    const onSubmit = values => {
      var tokenStr = localStorage.getItem('access_token')
      var user_id = localStorage.getItem('user_id')
  
      fetch(`${config.baseUrl}user/${user_id}/change-password/`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          'Accept': 'application/json',
          "Authorization": `Bearer ${tokenStr}`
        },
        body: JSON.stringify({ current_password: values.current_password, new_password: values.new_password, confirm_password: values.confirm_password })
      })
        .then(async response => {
          const results = await response.json()
          if (response.status === 200) {
            setDetail(results.message);
            setSeverityType("success");
            setOpenSnackbar(true);
            await sleep(2000);
            localStorage.clear()
            navigate('/')
            
          }
          else {
            setDetail(results.detail)
            setSeverityType("error");
            setOpenSnackbar(true);
            close();
          }
        })
        .catch((error)=>{
          console.error(error);
        })
    }

    const handleClickCurrent = () => {
      setShowCurrentPassword(prev => !prev);
    }
    const handleClickNew = () => {
      setShowNewPassword(prev => !prev);
    }
    const handleClickConfirm = () => {
      setShowConfirmPassword(prev => !prev);
    }
  
    function sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    }

    const handleSnackbarClose = (event, reason) => {
      if (reason === 'clickaway') {
        return;
      }
      setOpenSnackbar(false);
    };

    const handleDialogClose = (event, reason) => {
      if (reason !== 'backdropClick') {
        close();
      }
    };
    
  return (
    <Dialog
      onClose={handleDialogClose}
      aria-labelledby="customized-dialog-title"
      disableEscapeKeyDown={true}
      open={open}
      hideBackdrop={false}
    >
      <div className="forgot-modal-dialog-title">
        <DialogTitle
          sx={{ m: 0, py: "3px", width: "100%" }}
          id="customized-dialog-title"
        >
          Change Password
        </DialogTitle>
        <CancelOutlinedIcon
          aria-label="close"
          onClick={close}
          sx={{
            color: "white",
            fontSize: "28x",
            cursor: "pointer",
          }}
        />
      </div>
      <DialogContent dividers className="password-modal-body">
        <Formik
          initialValues={initialValues}
          validate={validate}
          onSubmit={onSubmit}
        >
          {({
            values,
            handleChange,
            handleBlur,
            handleSubmit,
            isSubmitting,
          }) => (
            <form onSubmit={handleSubmit}>
              <Typography variant="h6" gutterBottom className="forgot-bold">
                 <TextField
                    margin="normal"
                    fullWidth
                    id="current_password"
                    name="current_password"
                    type={showCurrentPassword ? "text" : "password"}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.current_password}
                    autoComplete="off"
                    placeholder="Current Password"
                    style={{ color: 'black' }}
                    variant="standard"
                    slotProps={{
                      input: {
                      startAdornment: (
                        <InputAdornment position="start">
                          <LockOpenRoundedIcon className="forgot-icons"/>
                        </InputAdornment>
                      ),
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            onClick={handleClickCurrent}
                            edge="end"
                            
                          >
                            {showCurrentPassword ? <Visibility className="forgot-icons" /> : <VisibilityOff className="forgot-icons" />}
                          </IconButton>
                        </InputAdornment>
                      )
                    },
                    }}
                  />
                <ErrorMessage
                  name="current_password"
                  component="div"
                  className="error"
                />
                <TextField
                    margin="normal"
                    fullWidth
                    id="new_password"
                    name="new_password"
                    type={showNewPassword ? "text" : "password"}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.new_password}
                    autoComplete="off"
                    onKeyDown={handleKeyDown}
                    placeholder="New Password"
                    style={{ color: 'black' }}
                    variant="standard"
                    slotProps={{
                      input: {
                      startAdornment: (
                        <InputAdornment position="start">
                          <LockOpenRoundedIcon className="forgot-icons"/>
                        </InputAdornment>
                      ),
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            onClick={handleClickNew}
                            edge="end"
                          >
                            {showNewPassword ? <Visibility className="forgot-icons" /> : <VisibilityOff className="forgot-icons" />}
                          </IconButton>
                        </InputAdornment>
                      )
                     }
                    }}
                  />
                <ErrorMessage
                position="start"
                  name="new_password"
                  component="div"
                  className="error"
                />
                <TextField
                      margin="normal"
                      fullWidth
                      id="confirm_password"
                      name="confirm_password"
                      type={showConfirmPassword ? "text" : "password"}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.confirm_password}
                      autoComplete="off"
                      onKeyDown={handleKeyDown}
                      placeholder="Confirm Password"
                      style={{ color: 'black' }}
                      variant="standard"
                      slotProps={{
                        input: {
                        startAdornment: (
                          <InputAdornment position="start">
                            <LockOpenRoundedIcon className="forgot-icons"/>
                          </InputAdornment>
                        ),
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              onClick={handleClickConfirm}
                              edge="end"
                              className="forgot-icons"
                            >
                              {showConfirmPassword ? <Visibility className="forgot-icons" /> : <VisibilityOff className="forgot-icons" />}
                            </IconButton>
                          </InputAdornment>
                        )
                      }
                      }}
                    />
                <ErrorMessage
                  name="confirm_password"
                  component="div"
                  className="error"
                />
               <Grid container spacing={2} className="form-layout-btn" style={{ justifyContent: 'center' }}>
                <Button
                  className="primary-btn"
                  type="submit"
                  variant="contained"
                  color="primary" >
                  Submit
                </Button>
                <Button
                  className="primary-btn-cancel"
                  variant="outlined"
                  color="primary"
                  onClick={close}
                  style={{ background: '#fff' }}
                >
                  Cancel
                </Button>
              </Grid>
              </Typography>
            </form>
          )}
        </Formik>
      </DialogContent>
      <Snackbar
        open={openSnackbar}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical, horizontal }}
      >
        <Alert elevation={6} variant="filled" onClose={handleSnackbarClose} severity={severityType}>
          <div className="error" style={{ color: "white" }}>
            <span>{detail}</span>
          </div>
        </Alert>
      </Snackbar>
    </Dialog>
  )
}

export default ChangePassword